module.exports = __webpack_public_path__ + "img/itemBar_02.e4332900.png";